import React, { useState, useEffect } from 'react';
import { 
  Leaf, Microscope, BookOpen, TrendingUp, Filter, Search, Eye, Clock, 
  MessageCircle, Heart, Bookmark, Share2, ChevronDown, ChevronRight,
  Award, Users, Calendar, Tag, ExternalLink, Download, Play,
  Beaker, Sprout, FileText, Globe, Star, ThumbsUp, ArrowRight,
  Video, PieChart, BarChart3, Activity, Bell, Sparkles, Trophy,
  Flame, Zap, X, Plus, ChevronUp, Target, Crown, Coffee,
  ArrowLeft, Reply, MoreHorizontal, ThumbsDown, Link, Flag, ArrowUp, ArrowDown
} from 'lucide-react';
import { researchAPI } from '../services/ResearchServices';
import CreateDiscussionDialog from '../components/CreateResearchDiscussionDialog';
import { useUser } from '../context/UserContext';
import { CommunityStatsCard } from '../components/CommunityStats';
import { RelatedArticlesSection } from '../components/RelatedArticlesComponents';
import PublicProfileView from '../profile_component/PublicProfileViewPage';
import { useTheme } from '../arrangement/ThemeContext';
// Enhanced Research Article Detail Component
const ResearchArticleDetail = ({ 
  handleOpenArticle,
  article, 
  tags,
  onBack, 
  liveChatMessages = [], 
  chatOnlineCount = 47,
  getCurrentChatTitle = () => "Research Chat",
  handleChatSubmit = () => {},
  newChatMessage = "",
  setNewChatMessage = () => {},
  selectedDiscussion = null,
  setSelectedDiscussion = () => {}
}) => {
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const [currentChatMessages, setCurrentChatMessages] = useState([]);
  const [currentChatTitle, setCurrentChatTitle] = useState("ResearrelatedDiscussionsch Chat");
  const { colors } = useTheme();

  const [relatedArticles, setRelatedArticles] = useState([]);
  const [loadingRelated, setLoadingRelated] = useState(false);

  const [isLiked, setIsLiked] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [isChatMinimized, setIsChatMinimized] = useState(false);

  const [selectedTag, setSelectedTag] = useState(null);
  const [commentVotes, setCommentVotes] = useState({}); // Track downvotes locally

  const { user: currentUser, isAuthenticated, login } = useUser();

  const [showProfileView, setShowProfileView] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const currentUserId = currentUser.id;

  const onLogin = () => {
    // You can either redirect to login page or show login modal
    // For example:
    window.location.href = '/login'; // or however you handle login
    // OR if you have a login modal: setShowLoginModal(true);
  };

  const [comments, setComments] = useState([]);
  const [replies, setReplies] = useState({});
  const [newComment, setNewComment] = useState('');
  const [showCommentForm, setShowCommentForm] = useState(false);
  const [relatedDiscussions, setRelatedDiscussions] = useState([]);
  const [trendingTopics, setTrendingTopics] = useState([]);
  const [sortBy, setSortBy] = useState('newest');

  const [loadingComments, setLoadingComments] = useState(true);
  const [loadingReplies, setLoadingReplies] = useState({});
  const [submittingComment, setSubmittingComment] = useState(false);
  const [replyVotes, setReplyVotes] = useState({}); // Track reply votes locally

  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [totalComments, setTotalComments] = useState(0);

  const [internalChatMessage, setInternalChatMessage] = useState('');


  const getRepliesForComment = (commentId) => {
    console.log('REPLIES ARE HERE: ',replies)
    return replies[commentId] || [];
  };

  const handleChatHeaderClick = () => {
    setIsChatMinimized(!isChatMinimized);
  };

  const handleUsernameClick = (userId) => {
    if (userId && userId !== currentUserId) {
      setSelectedUserId(userId);
      setShowProfileView(true);
    }
  };

  const handleReplyVote = async (replyId, discussionId, value) => {
    try {
      const response = await researchAPI.toggleReplyVote(replyId, value);
      
      // Update reply vote in replies state
      setReplies(prev => ({
        ...prev,
        [discussionId]: prev[discussionId]?.map(reply => 
          reply.id === replyId 
            ? { 
                ...reply, 
                like_count: response.like_count,
                user_vote: value,
                vote_count: response.vote_count || response.like_count
              }
            : reply
        ) || []
      }));

      // Update local vote tracking
      setReplyVotes(prev => ({
        ...prev,
        [replyId]: {
          isUpvoted: value === 1,
          isDownvoted: value === -1
        }
      }));

    } catch (error) {
      console.error('Failed to vote on reply:', error);
    }
  };

  const handleReplyDislike = async (replyId, discussionId) => {
    try {
      const response = await researchAPI.toggleReplyDislike(replyId);
      
      // Update local vote tracking
      setReplyVotes(prev => ({
        ...prev,
        [replyId]: {
          ...prev[replyId],
          isDownvoted: response.is_disliked,
          isUpvoted: response.clears_upvote ? false : prev[replyId]?.isUpvoted
        }
      }));

      // If it cleared an upvote, update the replies state
      if (response.clears_upvote) {
        setReplies(prev => ({
          ...prev,
          [discussionId]: prev[discussionId]?.map(reply => 
            reply.id === replyId 
              ? { 
                  ...reply, 
                  like_count: response.like_count,
                  user_vote: response.is_disliked ? -1 : 0
                }
              : reply
          ) || []
        }));
      }

    } catch (error) {
      console.error('Failed to dislike reply:', error);
    }
  };


  const organizeRepliesByDepth = (replyList) => {
    const organized = [];
    const replyMap = new Map();
    
    // First pass: create map of all replies
    replyList.forEach(reply => {
      replyMap.set(reply.id, { ...reply, children: [] });
    });
    
    // Second pass: organize into tree structure
    replyList.forEach(reply => {
      if (reply.depth === 1) {
        // Top-level reply
        organized.push(replyMap.get(reply.id));
      } else {
        // Find parent and add as child
        const parent = replyMap.get(reply.parentId);
        if (parent) {
          parent.children.push(replyMap.get(reply.id));
        }
      }
    });
    
    return organized;
  };
  const updateLiveChat = (messages, title) => {
    setCurrentChatMessages(messages);
    setCurrentChatTitle(title);
    setIsChatMinimized(false); // Auto-expand chat when comment is clicked
  };

  const loadRelatedArticles = async () => {
    try {
      setLoadingRelated(true);
      const response = await researchAPI.getRelatedArticles(article.id);
      setRelatedArticles(response.related_articles || []);
    } catch (error) {
      console.error('Failed to load related articles:', error);
      setRelatedArticles([]);
    } finally {
      setLoadingRelated(false);
    }
  };


  useEffect(() => {
    if (article?.id) {
      loadComments();
      loadTrendingTopics();
      loadRelatedArticles(); // Add this line
    }
  }, [article?.id, sortBy]);

  // Load comments from API
  const loadComments = async (page = 1) => {
    try {
      setLoadingComments(true);
      const response = await researchAPI.getArticleDiscussions(article.id, {
        page,
        per_page: 20,
        sort_by: sortBy
      });

      if (page === 1) {
        setComments(response.discussions);
        
        // ADD THIS: Initialize vote states for comments on first load
        const newVotes = {};
        response.discussions.forEach(discussion => {
          if (discussion.user_vote) {
            newVotes[discussion.id] = {
              isDisliked: discussion.user_vote === 'down',
              isLiked: discussion.user_vote === 'up'
            };
          }
        });
        setCommentVotes(newVotes);
        
      } else {
        setComments(prev => [...prev, ...response.discussions]);
        
        // UPDATE VOTE STATES FOR NEW COMMENTS
        const newVotes = {};
        response.discussions.forEach(discussion => {
          if (discussion.user_vote) {
            newVotes[discussion.id] = {
              isDisliked: discussion.user_vote === 'down',
              isLiked: discussion.user_vote === 'up'
            };
          }
        });
        setCommentVotes(prev => ({ ...prev, ...newVotes }));
      }

      setCurrentPage(page);
      setHasMoreComments(response.pagination.has_next);
      setTotalComments(response.pagination.total);

    } catch (error) {
      console.error('Failed to load comments:', error);
    } finally {
      setLoadingComments(false);
    }
  };
  
  const [showCreateDiscussion, setShowCreateDiscussion] = useState(false);


    const loadTrendingTopics = async () => {
    try {
      const response = await researchAPI.getTrendingTopics();
      setTrendingTopics(response.trending_topics || []);
    } catch (error) {
      console.error('Failed to load trending topics:', error);
      // Fallback to mock data
      setTrendingTopics([
        { tag: 'entourage-effect', posts: 89, growth: '+15%' },
        { tag: 'terpene-profiles', posts: 156, growth: '+23%' },
        { tag: 'cultivation-tips', posts: 234, growth: '+8%' },
        { tag: 'pain-management', posts: 187, growth: '+31%' }
      ]);
    }
  };

  // Load replies for a specific comment
  const loadReplies = async (discussionId) => {
    if (replies[discussionId] || loadingReplies[discussionId]) {
      return; // Already loaded or loading
    }

    try {
      setLoadingReplies(prev => ({ ...prev, [discussionId]: true }));
      
      const response = await researchAPI.getDiscussionReplies(discussionId);
      
      setReplies(prev => ({
        ...prev,
        [discussionId]: response.replies
      }));

      // ADD THIS: Initialize reply vote states
      const newReplyVotes = {};
      response.replies.forEach(reply => {
        if (reply.user_vote) {
          newReplyVotes[reply.id] = {
            isUpvoted: reply.user_vote === 'up',
            isDownvoted: reply.user_vote === 'down'
          };
        }
      });
      setReplyVotes(prev => ({ ...prev, ...newReplyVotes }));

    } catch (error) {
      console.error('Failed to load replies:', error);
    } finally {
      setLoadingReplies(prev => ({ ...prev, [discussionId]: false }));
    }
  };

const handleDiscussionSubmit = async (discussionData) => {
  try {
    const response = await researchAPI.createDiscussion(article.id, {
      title: discussionData.title,
      content: discussionData.content
    });
    
    // Add new discussion to the top of the list
    setComments(prev => [response.discussion, ...prev]);
    setTotalComments(prev => prev + 1);
    
  } catch (error) {
    console.error('Failed to submit discussion:', error);
    throw new Error(error.message || 'Failed to create discussion. Please try again.');
  }
};

  // Handle reply submission
  const handleReplySubmit = async (discussionId, content, parentReplyId = null) => {
    try {
      const response = await researchAPI.createReply(discussionId, content, parentReplyId);
      
      // Update replies state
      setReplies(prev => ({
        ...prev,
        [discussionId]: [...(prev[discussionId] || []), response.reply]
      }));

      // Update comment reply count
      setComments(prev => prev.map(comment => 
        comment.id === discussionId 
          ? { 
              ...comment, 
              like_count: response.like_count,
              user_vote: response.vote_type  // This is the key line
            }
          : comment
      ));

    } catch (error) {
      console.error('Failed to submit reply:', error);
      alert('Failed to submit reply. Please try again.');
    }
  };

  // Handle like/unlike discussion
  const handleDiscussionLike = async (discussionId) => {
    try {
      const response = await researchAPI.toggleDiscussionLike(discussionId);
      
      // Update comment like count and status
      setComments(prev => prev.map(comment => 
        comment.id === discussionId 
          ? { 
              ...comment, 
              like_count: response.like_count,
              is_liked: response.is_liked 
            }
          : comment
      ));

      // Clear downvote if backend says so
      if (response.clears_downvote) {
        setCommentVotes(prev => ({
          ...prev,
          [discussionId]: {
            ...prev[discussionId],
            isDisliked: false
          }
        }));
      }

    } catch (error) {
      console.error('Failed to toggle like:', error);
    }
  };


  // Handle like/unlike reply
  const handleReplyLike = async (replyId, discussionId) => {
    try {
      const response = await researchAPI.toggleReplyLike(replyId);
      
      // Update reply like count
      setReplies(prev => ({
        ...prev,
        [discussionId]: prev[discussionId]?.map(reply => 
          reply.id === replyId 
            ? { 
                ...reply, 
                like_count: response.like_count,
                is_liked: response.is_liked 
              }
            : reply
        ) || []
      }));

    } catch (error) {
      console.error('Failed to toggle reply like:', error);
    }
  };
;

  const handleDiscussionDislike = async (discussionId) => {
    try {
      console.log('HEHERHEHEEHHE')
      const response = await researchAPI.toggleDiscussionDislike(discussionId);
        console.log('HEHERHEHEEHHE')

      // Update local state based on backend response
      setCommentVotes(prev => ({
        ...prev,
        [discussionId]: {
          ...prev[discussionId],
          isDisliked: response.is_disliked
        }
      }));

      // If backend removed a like, update the comments state
      if (response.was_liked) {
        setComments(prev => prev.map(comment => 
          comment.id === discussionId 
            ? { 
                ...comment, 
                like_count: response.like_count,
                is_liked: false 
              }
            : comment
        ));
      }

    } catch (error) {
      console.error('Failed to toggle dislike:', error);
    }
  };

  const handleDiscussionLikeWithDownvoteCheck = async (discussionId) => {
  try {
    // Clear downvote when upvoting
    setCommentVotes(prev => ({
      ...prev,
      [discussionId]: {
        ...prev[discussionId],
        isDisliked: false
      }
    }));
    
    // Call existing like handler
    await handleDiscussionLike(discussionId);
  } catch (error) {
    console.error('Failed to toggle like:', error);
  }
};



const CommentCard = ({ 
  comment, 
  isSelected, 
  onSelect, 
  updateLiveChat, 
  loadReplies,
  replies,
  handleReplySubmit,
  handleDiscussionLike,
  handleReplyLike
}) => {
  // Local state for this comment card
  const [expandedReplies, setExpandedReplies] = useState(false);
  const [replyInput, setReplyInput] = useState('');
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [loadingReplies, setLoadingReplies] = useState(false);

  const commentVote = commentVotes[comment.id] || {};
  const isDisliked = commentVote.isDisliked || false;
  const adjustedLikeCount = comment.like_count || 0;



  // Get replies for this specific comment
  const commentReplies = replies[comment.id] || [];

  // Main click handler - expands forum thread
  const handleCommentClick = async (e) => {
    e.stopPropagation();
    
    // Toggle expansion
    const newExpandedState = !expandedReplies;
    setExpandedReplies(newExpandedState);
    
    // Select for any remaining chat functionality
    onSelect(comment.id);
    
    // Load replies if expanding and not already loaded
    if (newExpandedState && (!replies[comment.id] || replies[comment.id].length === 0)) {
      setLoadingReplies(true);
      try {
        await loadReplies(comment.id);
      } catch (error) {
        console.error('Failed to load replies:', error);
      } finally {
        setLoadingReplies(false);
      }
    }
  };

  // Submit reply
  const submitReply = async (e) => {
    e.stopPropagation();
    if (!replyInput.trim()) return;

    try {
      await handleReplySubmit(comment.id, replyInput.trim());
      setReplyInput('');
      setShowReplyForm(false);
      // Auto-expand replies after posting
      if (!expandedReplies) {
        setExpandedReplies(true);
      }
    } catch (error) {
      console.error('Failed to submit reply:', error);
    }
  };

  // Enhanced Reply Component with nested reply support
  const ReplyComponent = ({ reply, depth = 0 }) => {
    const [showReplyToReply, setShowReplyToReply] = useState(false);
    const [replyToReplyInput, setReplyToReplyInput] = useState('');

    const replyVote = replyVotes[reply.id] || {};
    const isUpvoted = reply.user_vote === 1 || replyVote.isUpvoted;
    const isDownvoted = reply.user_vote === -1 || replyVote.isDownvoted;


    // Submit nested reply
    const submitNestedReply = async (e) => {
      e.stopPropagation();
      if (!replyToReplyInput.trim()) return;

      try {
        await handleReplySubmit(comment.id, replyToReplyInput.trim(), reply.id);
        setReplyToReplyInput('');
        setShowReplyToReply(false);
      } catch (error) {
        console.error('Failed to submit nested reply:', error);
      }
    };

    return (
      <div style={{
        marginLeft: `${Math.min(depth * 24, 72)}px`,
        marginTop: '16px',
        borderLeft: '3px solid #333',
        paddingLeft: '20px',
        position: 'relative'
      }}>
        {/* Connection line */}
        <div style={{
          position: 'absolute',
          left: '-3px',
          top: '0',
          width: '20px',
          height: '24px',
          borderBottom: '3px solid #333',
          borderLeft: '3px solid #333',
          borderBottomLeftRadius: '12px'
        }} />
        
        <div style={{
          background: 'linear-gradient(135deg, #1e1e1e 0%, #2a2a2a 100%)',
          borderRadius: '12px',
          padding: '20px',
          border: '1px solid #444',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = '#555';
          e.currentTarget.style.transform = 'translateX(4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = '#444';
          e.currentTarget.style.transform = 'translateX(0)';
        }}
        >
          {/* Reply Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
            <img
              src={reply.avatar}
              alt={reply.author}
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid #444'
              }}
            />
            <span style={{ 
              fontSize: '14px', 
              color: '#00d4aa', 
              fontWeight: '600'
            }}>
              {reply.display_name || reply.author}
            </span>
            
            {reply.is_verified && (
              <div style={{
                background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                borderRadius: '50%',
                width: '16px',
                height: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Award size={10} style={{ color: 'white' }} />
              </div>
            )}
            
            <span style={{
              padding: '3px 8px',
              background: '#444',
              color: '#bbb',
              borderRadius: '6px',
              fontSize: '11px',
              fontWeight: '500'
            }}>
              {reply.level || reply.user_level}
            </span>
            
            <span style={{ fontSize: '12px', color: '#666' }}>•</span>
            <span style={{ fontSize: '12px', color: '#999' }}>
              <Clock size={12} style={{ display: 'inline', marginRight: '4px' }} />
              {reply.time_ago}
            </span>

            {/* Depth indicator */}
            {depth > 0 && (
              <>
                <span style={{ fontSize: '12px', color: '#666' }}>•</span>
                <span style={{ 
                  fontSize: '11px', 
                  color: '#00d4aa',
                  fontWeight: '600',
                  padding: '2px 6px',
                  background: '#00d4aa20',
                  borderRadius: '4px'
                }}>
                  Level {depth + 1}
                </span>
              </>
            )}
          </div>

          {/* Reply Content */}
          <div style={{
            margin: '0 0 16px 0',
            color: '#e0e0e0',
            fontSize: '14px',
            lineHeight: '1.6',
            wordWrap: 'break-word'
          }}>
            {reply.content}
          </div>

          {/* Reply Actions - UPDATED WITH UPVOTE/DOWNVOTE */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px',
            fontSize: '12px',
            borderTop: '1px solid #333',
            paddingTop: '12px',
            marginBottom: showReplyToReply ? '16px' : '0'
          }}>
            {/* Vote Section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {/* Upvote Button */}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  handleReplyVote(reply.id, comment.id, isUpvoted ? 0 : 1);
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  padding: '6px 8px',
                  background: isUpvoted 
                    ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)'
                    : 'transparent',
                  border: isUpvoted ? '1px solid #00d4aa' : '1px solid #555',
                  borderRadius: '6px',
                  color: isUpvoted ? 'white' : '#bbb',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (!isUpvoted) {
                    e.currentTarget.style.borderColor = '#00d4aa';
                    e.currentTarget.style.color = '#00d4aa';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isUpvoted) {
                    e.currentTarget.style.borderColor = '#555';
                    e.currentTarget.style.color = '#bbb';
                  }
                }}
              >
                <ArrowUp size={12} />
                {reply.like_count || reply.vote_count || 0}
              </button>

              {/* Downvote Button */}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  handleReplyDislike(reply.id, comment.id);
                }}
                style={{
                  padding: '6px',
                  background: isDownvoted 
                    ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)'
                    : 'transparent',
                  border: isDownvoted ? '1px solid #ef4444' : '1px solid #555',
                  borderRadius: '6px',
                  color: isDownvoted ? 'white' : '#bbb',
                  cursor: 'pointer',
                  fontSize: '12px',
                  fontWeight: '500',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (!isDownvoted) {
                    e.currentTarget.style.borderColor = '#ef4444';
                    e.currentTarget.style.color = '#ef4444';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isDownvoted) {
                    e.currentTarget.style.borderColor = '#555';
                    e.currentTarget.style.color = '#bbb';
                  }
                }}
              >
                <ArrowDown size={12} />
              </button>
            </div>

            <button 
              onClick={(e) => {
                e.stopPropagation();
                setShowReplyToReply(!showReplyToReply);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '6px 12px',
                background: showReplyToReply ? '#00d4aa20' : 'transparent',
                border: showReplyToReply ? '1px solid #00d4aa' : '1px solid #555',
                borderRadius: '6px',
                color: showReplyToReply ? '#00d4aa' : '#bbb',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (!showReplyToReply) {
                  e.currentTarget.style.borderColor = '#00d4aa';
                  e.currentTarget.style.color = '#00d4aa';
                }
              }}
              onMouseLeave={(e) => {
                if (!showReplyToReply) {
                  e.currentTarget.style.borderColor = '#555';
                  e.currentTarget.style.color = '#bbb';
                }
              }}
            >
              <Reply size={12} />
              Reply
            </button>

            <button style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              background: 'transparent',
              border: '1px solid #555',
              borderRadius: '6px',
              color: '#bbb',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500'
            }}>
              <Share2 size={12} />
              Share
            </button>
          </div>

          {/* Nested Reply Form */}
          {showReplyToReply && (
            <div style={{
              background: 'linear-gradient(135deg, #2a2a2a 0%, #333 100%)',
              borderRadius: '8px',
              padding: '16px',
              border: '2px solid #00d4aa30',
              boxShadow: '0 4px 16px rgba(0, 212, 170, 0.1)'
            }}
            onClick={(e) => e.stopPropagation()}
            >
              <div style={{
                fontSize: '12px',
                color: '#00d4aa',
                marginBottom: '8px',
                fontWeight: '600'
              }}>
                💬 Replying to {reply.author}
              </div>
              <textarea
                value={replyToReplyInput}
                onChange={(e) => setReplyToReplyInput(e.target.value)}
                placeholder={`Reply to ${reply.author}...`}
                style={{
                  width: '100%',
                  minHeight: '80px',
                  padding: '12px',
                  background: colors.bgTertiary,
                  border: '2px solid #444',
                  borderRadius: '6px',
                  color: '#e5e5e5',
                  fontSize: '13px',
                  resize: 'vertical',
                  outline: 'none',
                  boxSizing: 'border-box',
                  fontFamily: 'inherit',
                  lineHeight: '1.5'
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = '#00d4aa';
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#444';
                }}
              />
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button
                  onClick={submitNestedReply}
                  disabled={!replyToReplyInput.trim()}
                  style={{
                    padding: '8px 16px',
                    background: replyToReplyInput.trim() 
                      ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' 
                      : '#555',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: replyToReplyInput.trim() ? 'pointer' : 'not-allowed',
                    fontSize: '12px',
                    fontWeight: '600',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Post Reply
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowReplyToReply(false);
                    setReplyToReplyInput('');
                  }}
                  style={{
                    padding: '8px 16px',
                    background: 'transparent',
                    color: '#bbb',
                    border: '1px solid #555',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '500'
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  console.log(comment)
  return (
    <div style={{
      background: comment.isPinned 
        ? 'linear-gradient(135deg, #1a2e1a 0%, #1e3a1e 100%)' 
        : isSelected 
          ? 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)'
          : 'linear-gradient(135deg, #1a1a1a 0%, #1e1e1e 100%)',
      borderRadius: '16px',
      border: comment.isPinned 
        ? '2px solid #10b981' 
        : isSelected 
          ? '2px solid #00d4aa'
          : '1px solid #333',
      marginBottom: '24px',
      position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      transform: isSelected ? 'translateX(8px)' : 'translateX(0)',
      boxShadow: isSelected 
        ? '0 8px 32px rgba(0, 212, 170, 0.2)' 
        : '0 4px 16px rgba(0,0,0,0.1)'
    }}
    onMouseEnter={(e) => {
      if (!isSelected) {
        e.currentTarget.style.borderColor = '#00d4aa50';
        e.currentTarget.style.transform = 'translateX(4px)';
        e.currentTarget.style.boxShadow = '0 6px 24px rgba(0, 212, 170, 0.1)';
      }
    }}
    onMouseLeave={(e) => {
      if (!isSelected) {
        e.currentTarget.style.borderColor = '#333';
        e.currentTarget.style.transform = 'translateX(0)';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
      }
    }}
    >
      {/* Pinned Indicator */}
      {comment.isPinned && (
        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          padding: '10px 20px',
          fontSize: '12px',
          color: 'white',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          📌 Pinned Discussion
        </div>
      )}

      {/* Thread Expansion Indicator */}
      {expandedReplies && (
        <div style={{
          position: 'absolute',
          top: comment.isPinned ? '60px' : '16px',
          left: '16px',
          background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
          borderRadius: '20px',
          padding: '6px 12px',
          fontSize: '11px',
          color: 'white',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          zIndex: 2,
          boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
        }}>
          <ChevronDown size={12} />
          THREAD OPEN
        </div>
      )}

      <div 
        style={{ display: 'flex', padding: '24px' }}
        onClick={handleCommentClick}
      >
        {/* Vote Section */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
          minWidth: '70px',
          background: 'linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%)',
          padding: '16px 12px',
          borderRadius: '16px',
          border: '1px solid #333',
          marginRight: '20px'
        }}>
          {/* Upvote Button */}
          <button 
            onClick={(e) => {
              e.stopPropagation();
              handleDiscussionLike(comment.id);
            }}
            style={{
              padding: '8px',
              borderRadius: '12px',
              border: 'none',
              background: comment.is_liked || comment.user_vote === 'up'  // ADD THIS CHECK
                ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' 
                : 'white',
              color: (comment.is_liked || comment.user_vote === 'up') ? 'white' : '#6b7280',  // ADD THIS CHECK
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: (comment.is_liked || comment.user_vote === 'up') ? 'scale(1.1)' : 'scale(1)',  // ADD THIS CHECK
              boxShadow: (comment.is_liked || comment.user_vote === 'up') ? '0 4px 12px rgba(16, 185, 129, 0.4)' : '0 2px 4px rgba(0, 0, 0, 0.1)'  // ADD THIS CHECK
            }}
            onMouseEnter={(e) => {
              if (!comment.is_liked) {
                e.currentTarget.style.background = 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)';
                e.currentTarget.style.color = '#00d4aa';
                e.currentTarget.style.transform = 'scale(1.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (!comment.is_liked) {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#6b7280';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
          >
            <ArrowUp size={20} />
          </button>
          
          {/* Vote Count */}
          <span style={{
            fontWeight: 'bold',
            fontSize: '20px',
            color: (comment.is_liked || comment.user_vote === 'up') ? '#00d4aa' : 
                  (commentVotes[comment.id]?.isDisliked || comment.user_vote === 'down') ? '#ef4444' : '#374151',  // ADD CHECKS
            transition: 'all 0.3s ease'
          }}>
            {comment.like_count || 0}
          </span>
          
          {/* Downvote Button */}
          <button 
            onClick={(e) => {
              e.stopPropagation();
              handleDiscussionDislike(comment.id);
            }}
            style={{
              padding: '8px',
              borderRadius: '12px',
              border: 'none',
              background: (commentVotes[comment.id]?.isDisliked || comment.user_vote === 'down')  // ADD THIS CHECK
                ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' 
                : 'white',
              color: (commentVotes[comment.id]?.isDisliked || comment.user_vote === 'down') ? 'white' : '#6b7280',  // ADD THIS CHECK
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              transform: (commentVotes[comment.id]?.isDisliked || comment.user_vote === 'down') ? 'scale(1.1)' : 'scale(1)',  // ADD THIS CHECK
              boxShadow: (commentVotes[comment.id]?.isDisliked || comment.user_vote === 'down') ? '0 4px 12px rgba(239, 68, 68, 0.4)' : '0 2px 4px rgba(0, 0, 0, 0.1)'  // ADD THIS CHECK
            }}
            onMouseEnter={(e) => {
              if (!commentVotes[comment.id]?.isDisliked) {
                e.currentTarget.style.background = 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)';
                e.currentTarget.style.color = '#ef4444';
                e.currentTarget.style.transform = 'scale(1.05)';
              }
            }}
            onMouseLeave={(e) => {
              if (!commentVotes[comment.id]?.isDisliked) {
                e.currentTarget.style.background = 'white';
                e.currentTarget.style.color = '#6b7280';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
          >
            <ArrowDown size={20} />
          </button>
        </div>

        {/* Main Content */}
        <div style={{ flex: 1 }}>
          {/* Title Section */}
          {comment.title && (
            <div style={{ marginBottom: '16px' }}>
              <h2 style={{
                margin: '0 0 8px 0',
                fontSize: '20px',
                fontWeight: '700',
                color: '#e5e5e5',
                lineHeight: '1.4'
              }}>
                {comment.title}
              </h2>
            </div>
          )}

          {/* Author Info */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
            <img
              src={comment.avatar}
              alt={comment.author}
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2px solid #444'
              }}
            />
            <span style={{ fontSize: '14px', color: '#aaa' }}>Posted by</span>
            <span 
            onClick={() => handleUsernameClick(comment.user.id)}
            style={{ 
              fontSize: '14px', 
              color: '#00d4aa', 
              fontWeight: '600',
              cursor: comment.user.id !== currentUserId ? 'pointer' : 'default',
              transition: 'all 0.3s ease',
              textDecoration: 'none'
            }}
            onMouseEnter={(e) => {
              if (comment.user.id !== currentUserId) {
                e.currentTarget.style.textDecoration = 'underline';
                e.currentTarget.style.textDecorationColor = '#00d4aa';
                e.currentTarget.style.textUnderlineOffset = '2px';
                e.currentTarget.style.color = '#00d4aa';
              }
            }}
            onMouseLeave={(e) => {
              if (comment.user.id !== currentUserId) {
                e.currentTarget.style.textDecoration = 'none';
                e.currentTarget.style.color = '#00d4aa';
              }
            }}>
              {comment.display_name ||comment.author}
            </span>
            
            {(comment.isVerified || comment.is_verified) && (
              <div style={{
                background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                borderRadius: '50%',
                width: '18px',
                height: '18px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Award size={10} style={{ color: 'white' }} />
              </div>
            )}
            
            <span style={{
              padding: '4px 8px',
              background: '#444',
              color: '#bbb',
              borderRadius: '6px',
              fontSize: '11px',
              fontWeight: '500'
            }}>
              {comment.level}
            </span>
            
            <span style={{ fontSize: '12px', color: '#666' }}>•</span>
            <span style={{ fontSize: '12px', color: '#aaa' }}>
              <Clock size={12} style={{ display: 'inline', marginRight: '4px' }} />
              {comment.timeAgo || comment.time_ago}
            </span>

            {/* Thread Status Indicator */}
            <span style={{ fontSize: '12px', color: '#666' }}>•</span>
            <span style={{ 
              fontSize: '12px', 
              color: expandedReplies ? '#00d4aa' : '#888',
              fontWeight: expandedReplies ? '600' : '400'
            }}>
              🧵 {expandedReplies ? 'Thread Open' : 'Click to expand'}
            </span>
          </div>

          {/* Content */}
          <div style={{
            margin: '0 0 20px 0',
            color: '#ddd',
            fontSize: '15px',
            lineHeight: '1.6',
            wordWrap: 'break-word'
          }}>
            {comment.content}
          </div>

          {/* Action Buttons */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '16px',
            borderTop: '1px solid #333',
            paddingTop: '16px',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              background: expandedReplies ? '#00d4aa20' : 'transparent',
              border: expandedReplies ? '2px solid #00d4aa' : '1px solid #444',
              borderRadius: '8px',
              color: expandedReplies ? '#00d4aa' : '#bbb',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              {expandedReplies ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              <MessageCircle size={16} />
              {comment.replies || comment.reply_count || commentReplies.length} Replies
              {expandedReplies && <span style={{ marginLeft: '6px' }}>• Open</span>}
            </div>

            <button 
              onClick={(e) => {
                e.stopPropagation();
                setShowReplyForm(!showReplyForm);
              }}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                background: showReplyForm ? '#00d4aa20' : 'transparent',
                border: showReplyForm ? '2px solid #00d4aa' : '1px solid #444',
                borderRadius: '8px',
                color: showReplyForm ? '#00d4aa' : '#bbb',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease'
              }}
            >
              <Reply size={16} />
              Reply
            </button>

            <button style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              background: 'transparent',
              border: '1px solid #444',
              borderRadius: '8px',
              color: '#bbb',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              <Share2 size={16} />
              Share
            </button>

            {/* <button style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              background: 'transparent',
              border: '1px solid #444',
              borderRadius: '8px',
              color: comment.isBookmarked ? '#fbbf24' : '#bbb',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              <Bookmark size={16} />
              Save
            </button> */}
          </div>

          {/* Reply Input Form */}
          {showReplyForm && (
            <div style={{
              background: 'linear-gradient(135deg, #2a2a2a 0%, #333 100%)',
              borderRadius: '12px',
              padding: '20px',
              marginBottom: '20px',
              border: '2px solid #00d4aa30',
              boxShadow: '0 4px 16px rgba(0, 212, 170, 0.1)'
            }}
            onClick={(e) => e.stopPropagation()}
            >
              <textarea
                value={replyInput}
                onChange={(e) => setReplyInput(e.target.value)}
                placeholder="Share your thoughts..."
                style={{
                  width: '100%',
                  minHeight: '100px',
                  padding: '16px',
                  background: colors.bgTertiary,
                  border: '2px solid #444',
                  borderRadius: '8px',
                  color: '#e5e5e5',
                  fontSize: '14px',
                  resize: 'vertical',
                  outline: 'none',
                  boxSizing: 'border-box',
                  fontFamily: 'inherit',
                  lineHeight: '1.5'
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = '#00d4aa';
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = '#444';
                }}
              />
              <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
                <button
                  onClick={submitReply}
                  disabled={!replyInput.trim()}
                  style={{
                    padding: '12px 24px',
                    background: replyInput.trim() 
                      ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)' 
                      : '#555',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: replyInput.trim() ? 'pointer' : 'not-allowed',
                    fontSize: '14px',
                    fontWeight: '600',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Post Reply
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowReplyForm(false);
                    setReplyInput('');
                  }}
                  style={{
                    padding: '12px 24px',
                    background: 'transparent',
                    color: '#bbb',
                    border: '2px solid #555',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          {/* BEAUTIFUL FORUM THREAD EXPANSION */}
          {expandedReplies && (
            <div style={{ 
              marginTop: '20px',
              borderTop: '3px solid #00d4aa',
              background: 'linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%)',
              borderRadius: '16px',
              padding: '24px',
              border: '2px solid #00d4aa30',
              boxShadow: '0 8px 32px rgba(16, 185, 129, 0.2)', 
              position: 'relative'
            }}>
              {/* Glowing effect */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: 'linear-gradient(90deg, #00d4aa, #10b981, #34d399)',
                borderRadius: '16px 16px 0 0'
              }} />
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '20px'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  fontSize: '12px',
                  color: 'white',
                  fontWeight: '700',
                  letterSpacing: '0.5px'
                }}>
                  🧵 FORUM THREAD
                </div>
                <div style={{ 
                  fontSize: '16px', 
                  color: '#00d4aa', 
                  fontWeight: '600'
                }}>
                  {loadingReplies ? 'Loading replies...' : `${commentReplies.length} ${commentReplies.length === 1 ? 'Reply' : 'Replies'}`}
                </div>
              </div>
              
              {loadingReplies ? (
                <div style={{
                  textAlign: 'center',
                  color: '#00d4aa',
                  fontSize: '16px',
                  padding: '40px'
                }}>
                  <div style={{
                    display: 'inline-block',
                    width: '24px',
                    height: '24px',
                    border: '3px solid #00d4aa',
                    borderTop: '3px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  <div style={{ marginTop: '16px', fontWeight: '500' }}>Loading forum thread...</div>
                </div>
              ) : commentReplies.length > 0 ? (
                <div>
                  {commentReplies.map(reply => (
                    <ReplyComponent 
                      key={reply.id} 
                      reply={reply} 
                      depth={reply.depth || 1}
                    />
                  ))}
                </div>
              ) : (
                <div style={{
                  textAlign: 'center',
                  color: '#888',
                  fontSize: '16px',
                  padding: '40px',
                  border: '2px dashed #444',
                  borderRadius: '12px',
                  background: colors.bgTertiary,
                }}>
                  <MessageCircle size={32} style={{ marginBottom: '12px', opacity: 0.5 }} />
                  <div style={{ fontWeight: '500' }}>No replies yet. Be the first to respond!</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
  const handleDiscussionClick = (discussion) => {
    setSelectedDiscussion(discussion);
    
    // Different comment sets for each discussion
    if (discussion.id === 6) {
      setComments([
        {
          id: 101,
          author: 'ExtractionExpert',
          avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=40&h=40&fit=crop&crop=face',
          level: 'Lab Tech',
          levelIcon: '⚗️',
          timeAgo: '1 hour ago',
          content: 'CO2 extraction at lower temperatures preserves 89% more terpenes. The key is maintaining pressure while reducing heat.',
          likes: 34,
          replies: 7,
          isLiked: false,
          isVerified: true,
          badges: ['Extraction Specialist']
        }
      ]);
    } else if (discussion.id === 7) {
      setComments([
        {
          id: 201,
          author: 'WellnessDoc',
          avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=40&h=40&fit=crop&crop=face',
          level: 'Medical Professional',
          levelIcon: '🩺',
          timeAgo: '30 min ago',
          content: 'Patient reported 40% reduction in anxiety with 10mg CBD + 5mg CBG. The synergy is remarkable.',
          likes: 67,
          replies: 15,
          isLiked: false,
          isVerified: true,
          badges: ['Medical Expert'],
          isPinned: true
        }
      ]);
    }
    
    setSelectedCommentId(null); // Reset selected comment
  };

  return (
    <div style={{
      backgroundColor: '#0a0a0a',
      color: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{
        background: colors.bgTertiary,
        borderBottom: `1px solid ${colors.border}`,
        padding: '16px 24px',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={onBack}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              background: 'transparent',
              border: '1px solid #333',
              borderRadius: '8px',
              color: '#888',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s ease'
            }}
          >
            <ArrowLeft size={16} />
            Back to Research Hub
          </button>

          <div style={{ flex: 1 }}>
            <h1 style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: '600',
              color: '#e5e5e5'
            }}>
              Research Discussion
            </h1>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 350px', gap: '32px' }}>
          {/* Main Content */}
          <div>
            {/* Research Article Card */}
            <div style={{
              background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
              borderRadius: '20px',
              padding: '24px',
              border: '1px solid #333',
              marginBottom: '24px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '200px',
                height: '200px',
                background: 'radial-gradient(circle, #00d4aa10 0%, transparent 70%)',
                pointerEvents: 'none'
              }} />

              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ display: 'flex', gap: '20px' }}>
                  <div style={{
                    width: '120px',
                    height: '80px',
                    borderRadius: '12px',
                    background: 'linear-gradient(45deg, #00d4aa20, #10b98120)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    border: '1px solid #00d4aa30'
                  }}>
                    🔬
                  </div>

                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                      <span style={{
                        padding: '4px 8px',
                        background: '#3b82f6',
                        color: 'white',
                        borderRadius: '8px',
                        fontSize: '11px',
                        fontWeight: '600'
                      }}>
                        Research
                      </span>
                      <span style={{
                        padding: '4px 8px',
                        background: '#fbbf24',
                        color: 'white',
                        borderRadius: '8px',
                        fontSize: '11px',
                        fontWeight: '600'
                      }}>
                        Peer Reviewed
                      </span>
                    </div>

                    <h2 style={{
                      margin: '0 0 8px 0',
                      fontSize: '20px',
                      fontWeight: '700',
                      color: '#e5e5e5',
                      lineHeight: '1.3'
                    }}>
                      {article.title}
                    </h2>

                    <p style={{
                      margin: '0 0 16px 0',
                      fontSize: '14px',
                      color: '#10b981',
                      fontWeight: '500'
                    }}>
                      {article.subtitle}
                    </p>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', fontSize: '12px', color: '#888', marginBottom: '16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Globe size={12} />
                        {article.institution}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Calendar size={12} />
                        {article.publishedDate}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Clock size={12} />
                        {article.read_time} min read
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '12px' }}>
                      <button
                      onClick={() => window.open(article.url, '_blank')}
                      style={{
                        padding: '12px 20px',
                        background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '12px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        transition: 'all 0.3s ease'
                      }}>
                        <ExternalLink size={14} />
                        Read Full Study
                      </button>

                      <button
                        onClick={() => setIsBookmarked(!isBookmarked)}
                        style={{
                          padding: '12px',
                          background: isBookmarked ? 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)' : 'transparent',
                          border: '1px solid',
                          borderColor: isBookmarked ? '#fbbf24' : '#333',
                          borderRadius: '12px',
                          color: isBookmarked ? 'white' : '#888',
                          cursor: 'pointer'
                        }}
                      >
                        <Bookmark size={14} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Comment Form */}
            {/* <div style={{
              background: colors.bgTertiary,
              borderRadius: '16px',
              padding: '20px',
              border: '1px solid #333',
              marginBottom: '24px'
            }}>
              <h3 style={{ margin: '0 0 16px 0', color: '#e5e5e5', fontSize: '16px', fontWeight: '600' }}>
                💬 Join the Discussion
              </h3>
              
              {!showCommentForm ? (
                <button
                  onClick={() => setShowCommentForm(true)}
                  style={{
                    width: '100%',
                    padding: '16px',
                    background: colors.bgCard,
                    border: '1px solid #333',
                    borderRadius: '12px',
                    color: '#888',
                    cursor: 'pointer',
                    fontSize: '14px',
                    textAlign: 'left',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Share your thoughts, experiences, or questions about this research...
                </button>
              ) : (
                <form onSubmit={handleCommentSubmit}>
                  <textarea
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    placeholder="What's your take on this research? Share insights, ask questions, or discuss applications..."
                    style={{
                      width: '100%',
                      minHeight: '120px',
                      padding: '16px',
                      background: colors.bgCard,
                      border: '1px solid #333',
                      borderRadius: '12px',
                      color: '#e5e5e5',
                      fontSize: '14px',
                      resize: 'vertical',
                      outline: 'none',
                      boxSizing: 'border-box',
                      lineHeight: '1.5'
                    }}
                  />
                  <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                    <button
                      type="submit"
                      style={{
                        padding: '10px 20px',
                        background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      Post Comment
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setShowCommentForm(false);
                        setNewComment('');
                      }}
                      style={{
                        padding: '10px 20px',
                        background: 'transparent',
                        color: '#888',
                        border: '1px solid #333',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div> */}

            {/* Comments Header */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '20px'
            }}>
              <h3 style={{ margin: 0, color: '#e5e5e5', fontSize: '18px', fontWeight: '600' }}>
                Discussion ({comments.length})
              </h3>
              <button 
                onClick={() => setShowCreateDiscussion(true)}
                style={{
                  padding: '12px 20px',
                  background: 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease'
                }}
              >
                <ExternalLink size={14} />
                Create Discussion Thread
              </button>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                style={{
                  padding: '8px 12px',
                  background: colors.bgCard,
                  border: '1px solid #333',
                  borderRadius: '8px',
                  color: '#e5e5e5',
                  fontSize: '14px'
                }}
              >
                <option value="newest">Newest First</option>
                <option value="oldest">Oldest First</option>
                <option value="popular">Most Popular</option>
                <option value="pinned">Pinned First</option>
              </select>
            </div>

            {/* Comments */}
           {comments.map(comment => (
                <CommentCard 
                  key={comment.id} 
                  comment={comment} 
                  isSelected={selectedCommentId === comment.id}
                  onSelect={setSelectedCommentId}
                  updateLiveChat={updateLiveChat}
                  loadReplies={loadReplies}
                  replies={replies} // Pass the replies state
                  handleReplySubmit={handleReplySubmit}
                  handleDiscussionLike={handleDiscussionLike}
                  handleReplyLike={handleReplyLike}
                />
              ))}
          </div>

          {/* Sidebar */}
          <div>
            {/* Trending Topics */}
            <div style={{
              marginBottom: '24px',
              padding: '20px',
              background: colors.bgTertiary,
              borderRadius: '16px',
              border: '1px solid #333'
            }}>
              <h3 style={{
                margin: '0 0 12px 0',
                fontSize: '14px',
                fontWeight: '600',
                color: '#e5e5e5',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Tag size={14} />
                Research Topics
                {selectedTag && (
                  <button
                    onClick={() => setSelectedTag(null)}
                    style={{
                      padding: '2px 6px',
                      background: '#ef4444',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '10px',
                      cursor: 'pointer',
                      marginLeft: '8px'
                    }}
                  >
                    Clear
                  </button>
                )}
              </h3>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
              }}>
                {tags.map(tag => (
                  <button
                    key={tag}
                    onClick={() => setSelectedTag(selectedTag === tag ? null : tag)}
                    style={{
                      padding: '6px 12px',
                      background: selectedTag === tag 
                        ? 'linear-gradient(135deg, #00d4aa 0%, #10b981 100%)'
                        : 'transparent',
                      color: selectedTag === tag ? 'white' : '#888',
                      border: '1px solid',
                      borderColor: selectedTag === tag ? '#00d4aa' : '#333',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: '500',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      if (selectedTag !== tag) {
                        e.currentTarget.style.borderColor = '#00d4aa';
                        e.currentTarget.style.color = '#00d4aa';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedTag !== tag) {
                        e.currentTarget.style.borderColor = '#333';
                        e.currentTarget.style.color = '#888';
                      }
                    }}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
              <RelatedArticlesSection
                colors={colors}
                article={article}
                handleOpenArticle={handleOpenArticle}
                relatedArticles={relatedArticles}
                loadingRelated={loadingRelated}
                />


            <CommunityStatsCard />
          </div>
        </div>
      </div>

      {/* Enhanced Live Chat Widget for Article Detail Page */}
      

      {/* CSS for animations */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.8; }
        }
        
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      {showCreateDiscussion && (
        <CreateDiscussionDialog 
          isOpen={showCreateDiscussion}
          onClose={() => setShowCreateDiscussion(false)}
          onSubmit={handleDiscussionSubmit} // Use your existing handleCommentSubmit function
          currentUser={currentUser}
          isAuthenticated={isAuthenticated}
          onLogin={onLogin}
        />
      )}
      {showProfileView && selectedUserId && (
        <PublicProfileView
          userId={selectedUserId}
          currentUserId={currentUserId}
          onClose={() => {
            setShowProfileView(false);
            setSelectedUserId(null);
          }}
        />
      )}
    </div>
  );
};

export default ResearchArticleDetail;